import { Award, Lock } from "lucide-react";

const TIER = {
  bronce: "from-amber-600 to-orange-400",
  plata: "from-slate-400 to-slate-200",
  oro: "from-yellow-500 to-amber-300",
  diamante: "from-cyan-500 to-sky-300",
};

export const Medal = ({ m, size = "md" }) => {
  const s = size === "sm" ? "h-12 w-12" : "h-16 w-16";
  return (
    <div className="flex flex-col items-center text-center" data-testid={`medal-${m.id}`}>
      <div className={`relative flex ${s} items-center justify-center rounded-full ${m.unlocked ? `bg-gradient-to-br ${TIER[m.tier]} shadow-md` : "bg-stone-100"}`}>
        {m.unlocked ? <Award className="h-1/2 w-1/2 text-white" /> : <Lock className="h-5 w-5 text-stone-300" />}
        <span className={`absolute -bottom-1 rounded-full px-1.5 text-[10px] font-extrabold ${m.unlocked ? "bg-ink text-white" : "bg-stone-200 text-stone-500"}`}>{m.days}</span>
      </div>
      <p className={`mt-2 text-xs font-semibold ${m.unlocked ? "text-ink" : "text-stone-400"}`}>{m.name}</p>
    </div>
  );
};

export const MedalsRow = ({ streak }) => {
  const unlocked = streak.medals.filter((m) => m.unlocked).length;
  const next = streak.next_medal;
  return (
    <div className="card-clay p-5 sm:p-6" data-testid="medals-card">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <p className="text-sm font-bold">Medallas de racha <span className="text-stone-500" data-testid="medals-count">{unlocked}/{streak.medals.length}</span></p>
        {next && <p className="text-xs text-stone-600" data-testid="medals-next">Te faltan <strong>{next.remaining}</strong> días para «{next.name}»</p>}
      </div>
      {next && (
        <div className="mt-3 h-2 overflow-hidden rounded-full bg-stone-100">
          <div className="h-full rounded-full bg-streak transition-[width] duration-700" style={{ width: `${Math.round(((next.days - next.remaining) / next.days) * 100)}%` }} />
        </div>
      )}
      <div className="no-scrollbar -mx-1 mt-5 flex gap-4 overflow-x-auto px-1 pb-1">
        {streak.medals.map((m) => <div key={m.id} className="w-20 shrink-0"><Medal m={m} size="sm" /></div>)}
      </div>
    </div>
  );
};
